import { render, staticRenderFns } from "./AddPropertyCommunity.vue?vue&type=template&id=79aafd4f"
import script from "./AddPropertyCommunity.vue?vue&type=script&lang=js"
export * from "./AddPropertyCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports